// document.addEventListener('DOMContentLoaded', function() {
//   const buttons = document.querySelectorAll('.tab-buttons button');
//   const contents = document.querySelectorAll('.tab-content');

//   buttons.forEach(button => {
//     button.addEventListener('click', () => {
//       buttons.forEach(btn => btn.classList.remove('active'));
//       button.classList.add('active');

//       contents.forEach(content => content.classList.remove('active'));
//       document.getElementById(button.dataset.tab).classList.add('active');
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.tab-buttons button');
  const contents = document.querySelectorAll('.tab-content');

  buttons.forEach(button => {
    button.addEventListener('click', function () {

      // =========================
      // 1. TAB SWITCHING
      // =========================
      buttons.forEach(btn => btn.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));

      this.classList.add('active');

      const tabId = this.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');


      // =========================
      // 2. SECTION CONTROL (PURE ID)
      // =========================

      // hide ALL sections that have an ID
      document.querySelectorAll('[id]').forEach(el => {
        // only hide sections that match tab pattern
        if (el.id.startsWith('tab-')) {
          el.style.display = 'none';
        }
      });

      // show matching sections
      document.querySelectorAll('#' + tabId).forEach(el => {
        el.style.display = 'block';
      });

    });
  });

  // trigger first tab
  if (buttons.length > 0) {
    buttons[0].click();
  }

});